const MAX_CAROUSEL_ITEMS = 15;

const selectCategoryBySlug = (state, categorySlug) => {
  const categoryId = state.idsBySlug[categorySlug];

  return state.byId[categoryId];
};

const selectFeaturedCategoryAppsByCategorySlug = (state, categorySlug) => {
  const categoryId = state.categories.idsBySlug[categorySlug];

  return state.apps.featuredAppIdsByCategoryId(categoryId);
};

const selectCategoryAppsByCategorySlug = (state, categorySlug) => {
  const categoryId = state.categories.idsBySlug[categorySlug];
  const categoryAppIds = state.apps.idsByCategoryId[categoryId];

  return categoryAppIds.map((categoryAppId) => state.apps.byId[categoryAppId]);
};

/**
 * Gets the first 15 featured app Ids,
 * used on the Home view featured apps carousel
 *
 * @param {Object} state
 *
 * @returns {Array}
 */
const selectAllFeaturedAppIds = (state) =>
  state.apps.allFeaturedAppIds.slice(0, MAX_CAROUSEL_ITEMS);

/**
 * Get the first 15 featured app Ids by category Id
 *
 * @param {Object} state
 * @param {String} categoryId
 *
 * @returns {Array}
 */
const selectFeaturedAppIdsByCategoryId = (state, categoryId) =>
  state.apps.featuredAppIdsByCategoryId[categoryId]
    ? state.apps.featuredAppIdsByCategoryId[categoryId].slice(
        0,
        MAX_CAROUSEL_ITEMS,
      )
    : [];

const selectPaginatedAppIdsByPageNumber = (state, pageNumber) =>
  state.idsByPage[pageNumber] || [];

const selectRelatedAppsByAppId = (state, appId) => {
  const relatedAppIds =
    typeof state.apps.byId[appId] !== 'undefined' &&
    typeof state.apps.byId[appId].relatedAppIds === 'object' &&
    state.apps.byId[appId].relatedAppIds.length > 0
      ? state.apps.byId[appId].relatedAppIds
      : [];

  return relatedAppIds.map((relatedAppId) =>
    typeof state.apps.byId[relatedAppId] !== 'undefined'
      ? state.apps.byId[relatedAppId]
      : null,
  );
};

const selectRelatedAppsByCategoryId = (state, categoryId) =>
  Object.prototype.hasOwnProperty.call(state.idsByCategoryId, categoryId) &&
  state.idsByCategoryId[categoryId].length > 0
    ? state.idsByCategoryId[categoryId].map((appId) =>
        Object.prototype.hasOwnProperty.call(state.byId, appId)
          ? state.byId[appId]
          : null,
      )
    : [];

// TODO: read state.apps.view when caching paginated apps per view
const getAppIdsForCurrentView = (state) => [].concat(...state.apps.idsByPage);

/* Search selectors */

const selectAppsSearchResults = (state, maxNumberResults) => {
  const appsSearchResults = maxNumberResults
    ? state.apps.searchResultsIds.slice(0, maxNumberResults)
    : state.apps.searchResultsIds;

  return appsSearchResults.map(
    (appsSearchResultId) => state.apps.byId[appsSearchResultId],
  );
};

const hasSearchResults = (state) => state.apps.searchResultsIds.length > 0;

/* Views & pagination selectors */

// TODO: pass a view parameter when caching paginated apps per view
const getNextPage = (state) => state.apps.idsByPage.length;

const getAppsView = (state) => state.apps.view;

/* Routing selectors */

const getAppUrl = (app) => `/apps/${app.slug}`;

const getCategoryUrl = (category) => `/categories/${category.slug}`;

export {
  getAppIdsForCurrentView,
  selectAppsSearchResults,
  hasSearchResults,
  selectAllFeaturedAppIds,
  selectFeaturedAppIdsByCategoryId,
  selectPaginatedAppIdsByPageNumber,
  selectRelatedAppsByAppId,
  selectRelatedAppsByCategoryId,
  selectCategoryBySlug,
  selectFeaturedCategoryAppsByCategorySlug,
  selectCategoryAppsByCategorySlug,
  getNextPage,
  getAppsView,
  getAppUrl,
  getCategoryUrl,
};
